import { getPluralizedType } from 'pages/people/utilities'

export const groupsToNamedTypes = (groups, options = {}) => {
    const { ids = false } = options

    const groupedByType = Object.groupBy(groups, group => group.type)

    return Object.fromEntries(
        Object.entries(groupedByType).map(([type, groupsOfType]) => [
            getPluralizedType(type),
            groupsOfType.map(group => ids ? group.id : group)
        ])
    )
}